// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__39_Gf","modalFooterButton":"ModalNotes_modalFooterButton__1A5NQ"};